import { useEffect, useState } from 'react';
import DomainApi from 'libs/api/domains';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import 'moment/locale/it';
const api = new DomainApi();

const useDomainCharts = (query) => {
  const {
    i18n: { language },
    t,
  } = useTranslation();
  // moment.locale(language);
  const range = [
    moment(query.get('date_from'), 'YYYY-MM-DD')
      .subtract(1, 'week')
      .format('YYYY-MM-DD'),
    moment(query.get('date_to'), 'YYYY-MM-DD').format('YYYY-MM-DD'),
  ];
  const [label, setLabel] = useState(t('Messaggi/ora'));
  const [dateRange] = useState(range);

  const [chartsData, setChartsData] = useState({
    sendData: [],
    openedData: [],
    failedData: [],
    pendingData: [],
    clickedData: [],
    unsubscriptionData: [],
    deliveredData: [],
    newDataSend: [],
    total: {
      clicked: 0,
      delivered: 0,
      failed: 0,
      opened: 0,
      pending: 0,
      send: 0,
      unsubscription: 0,
    },
  });

  const getDomainsAnalyticsData = async () => {
    try {
      const params = {
        params: {
          date_from: query.get('date_from'),
          date_to: query.get('date_to'),
          domain_id: query.get('domain_id'),
          type: 'hour',
        },
      };

      const firstDate = moment(dateRange[0], 'DD/MM/YYYY');
      const secondDate = moment(dateRange[1], 'DD/MM/YYYY');
      let formatType = 'DD/MM/YYYY HH:mm';
      let label = t('Messaggi/ora');
      if (secondDate.diff(firstDate, 'days') > 7) {
        params.params.type = 'day';
        formatType = 'DD/MM/YYYY';
        label = t('Messaggi/giorno');
      }

      if (secondDate.diff(firstDate, 'month', true) > 1) {
        params.params.type = 'month';
        formatType = 'MMM/YYYY';
        label = t('Messaggi/mese');
      }
      setLabel(label);
      const { data } = await api.getMessageChartAnalytics(
        query.get('email_id'),
        params,
      );
      const sendData = [];
      const openedData = [];
      const failedData = [];
      const pendingData = [];
      const clickedData = [];
      const unsubscriptionData = [];

      const { clicked, failed, opened, pending, send, unsubscription } =
        data.data;

      const { total } = data;

      const newDataSend = [];

      const addData = (arr, i) => {
        arr.push({
          name: moment(i[0], 'YYYY-MM-DD HH:mm')
            .format(formatType)
            .toUpperCase(),
          [label]: i[1],
        });
      };

      Object.entries(send).forEach((i) => {
        addData(sendData, i);
      });

      Object.entries(opened).forEach((i) => {
        addData(openedData, i);
      });

      Object.entries(failed).forEach((i) => {
        addData(failedData, i);
      });

      Object.entries(pending).forEach((i) => {
        addData(pendingData, i);
      });

      Object.entries(clicked).forEach((i) => {
        addData(clickedData, i);
      });

      Object.entries(unsubscription).forEach((i) => {
        addData(unsubscriptionData, i);
      });

      setChartsData({
        sendData,
        openedData,
        failedData,
        pendingData,
        clickedData,
        unsubscriptionData,
        newDataSend,
        total,
      });
      const event = new CustomEvent('status', { detail: 'ok' });
      window.addEventListener('status', function (e) {
        console.log('status: ', e.detail);
      });
      setTimeout(() => {
        window.dispatchEvent(event);
      }, 5000);
    } catch (e) {
      console.log(e);
      setChartsData({
        sendData: [],
        openedData: [],
        failedData: [],
        pendingData: [],
        clickedData: [],
        unsubscriptionData: [],
        newDataSend: [],
        total: {},
      });
      const event = new CustomEvent('status', { detail: 'ok' });
      window.addEventListener('status', function (e) {
        console.log('status: ', e.detail);
      });
      setTimeout(() => {
        window.dispatchEvent(event);
      }, 5000);
    }
  };

  useEffect(async () => {
    await getDomainsAnalyticsData();
  }, [dateRange, language]);

  return {
    chartsData,
    label,
  };
};

export default useDomainCharts;
